import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { itwApi } from '@application/api/middlewares/api';
// Initial state
const initialState = {
    liveStreamUrl: null,
    loading: false,
    error: null
};
// Async thunk for getting live stream URL
export const getLiveStreamUrl = createAsyncThunk('liveStream/getLiveStreamUrl', async (query, { rejectWithValue }) => {
    try {
        const response = await itwApi.get(`/System/get-live-stream?systemId=${query.systemId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unexpected error occurred');
    }
});
// Slice
const liveStreamSlice = createSlice({
    name: 'liveStream',
    initialState,
    reducers: {
        clearLiveStreamUrl: (state) => {
            state.liveStreamUrl = null;
            state.error = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Get live stream URL
            .addCase(getLiveStreamUrl.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(getLiveStreamUrl.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.isSuccess) {
                state.liveStreamUrl = action.payload.data;
                state.error = null;
            }
            else {
                state.error = action.payload.message || 'Failed to get live stream URL';
            }
        })
            .addCase(getLiveStreamUrl.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Failed to get live stream URL';
        });
    }
});
// Export actions
export const { clearLiveStreamUrl, clearError } = liveStreamSlice.actions;
// Export reducer
export default liveStreamSlice.reducer;
